/* ==========================================================================
   Dynoforce shopfilters zonder herladen

   De filterbalk zette een vinkje om in een nieuw adres en liet de browser de
   hele pagina opnieuw laden. Dat kost een seconde, en erger: je staat weer
   bovenaan terwijl je net bij het grid keek. Hier vangen we die acties op en
   halen alleen de twee secties op die echt veranderen - de filterbalk (de
   aantallen en de actieve staat lopen mee) en het productgrid.

   Dat gaat via de sectie-route van Shopify: dezelfde url met ?sections=<id>
   geeft de gerenderde html van die secties terug. Dus geen tweede weergave in
   JavaScript die uit de pas kan lopen met de Liquid: het is dezelfde sectie,
   alleen dan zonder de rest van de pagina eromheen.

   Werkt JavaScript niet, of gaat de opvraging mis, dan blijft alles zoals het
   was: de balk staat in een gewoon <form method="get"> met echte links, en bij
   een fout sturen we de browser alsnog gewoon naar dat adres.

   De uitklappers, het zoekveld binnen een filter en het sluiten met Escape
   zaten eerst in een script in de sectie zelf. Dat werkt hier niet meer: zodra
   we de balk vervangen is dat script zijn elementen kwijt. Daarom staat alles
   nu op document met gedelegeerde luisteraars, die een vervanging overleven.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__dfShopAjax) return;
  window.__dfShopAjax = true;

  var BREED = window.matchMedia('(min-width:768px)');
  var RUSTIG = window.matchMedia('(prefers-reduced-motion: reduce)');

  function balk() { return document.querySelector('[data-df-fb]'); }
  function grid() { return document.querySelector('[data-df-grid]'); }
  function sectieVan(el) { return el ? el.getAttribute('data-df-sectie') : null; }

  /* De knoppen "Toon resultaten" horen alleen te staan als JavaScript uit is.
     De sectie zet deze klasse zelf al bij het inladen; hier zetten we hem
     terug na elke vervanging. */
  function merkJs() {
    var b = balk();
    if (b) b.classList.add('df-fb--js');
  }

  /* Echt lege collectie (audit SHOP-4, 17-10-2026): nul producten zonder een
     actief filter. Dan valt er niets te sorteren of te filteren en blijven
     de sorteerkeuze, de knop in de pagina en de zwevende knop weg. De
     filterbalk zet daarvoor zelf de klasse en data-df-leeg="ja" bij het
     renderen, en df-productgrid zet dezelfde vlag op het grid. Na een
     verversing rendert de server de balk opnieuw, dus meestal staat de
     klasse er al; hier kijken we ook naar de vlag op het grid, en als die
     er niet is naar wat er staat: geen enkele kaart en geen enkel actief
     filterlabel. Met een filter aan en nul treffers is de balk juist nodig
     om dat filter weer uit te zetten. */
  function leeg() {
    var g = grid(), b = balk();
    if (!g || !b) return false;
    if (g.getAttribute('data-df-leeg') === 'ja' || b.getAttribute('data-df-leeg') === 'ja') return true;
    return !g.querySelector('.df-pk, .df-zr__tk') && !b.querySelector('.df-fb__pil');
  }
  function zetLeeg() {
    var b = balk();
    if (b) b.classList.toggle('df-fb--leeg', leeg());
  }

  /* ---------- uitklappers ---------- */

  function groepen() {
    var b = balk();
    return b ? Array.prototype.slice.call(b.querySelectorAll('.df-fb__grp')) : [];
  }

  function sluitAlles(behalve) {
    groepen().forEach(function (g) { if (g !== behalve) g.open = false; });
  }

  /* toggle bubbelt niet, dus opvangen in de capture-fase. */
  document.addEventListener('toggle', function (e) {
    var g = e.target;
    if (!g || !g.classList || !g.classList.contains('df-fb__grp')) return;
    if (g.open && BREED.matches) sluitAlles(g);
  }, true);

  document.addEventListener('click', function (e) {
    var b = balk();
    if (!b || b.contains(e.target)) return;
    if (!BREED.matches) return;
    sluitAlles(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (paneelOpen()) { zetPaneel(false); return; }
    sluitAlles(null);
  });

  /* ---------- het paneel op een telefoon ----------
     Onder 768 px is het filterformulier een schermvullend paneel (CSS in de
     sectie: .df-fb--open op de wortel). Hier gaat het open en dicht, en de
     html krijgt een klasse die het scrollen eronder stillegt. De knop
     "Toon n artikelen" onderin sluit het paneel en brengt je naar het grid
     als dat nog niet in beeld staat. De stand (open of dicht, en hoe ver
     het paneel gescrold was) gaat in standNu() mee over een vervanging
     heen, want elk vinkje vervangt de hele sectie, paneel en al. */

  var LOCK = 'df-fb-lock';

  function paneelOpen() {
    var b = balk();
    return !!(b && b.classList.contains('df-fb--open'));
  }

  /* De sectie krijgt bij het verschijnen een animatie met een transform
     (df-reveal op .shopify-section). Zolang die transform staat is een
     position:fixed-element niet aan het scherm maar aan de sectie gebonden:
     het paneel stond dan als strook van 58 px op de plek van de knop, tot de
     animatie klaar was (gezien 10-10-2026). Een keer uitzetten is genoeg;
     de sectie is op dat moment toch al in beeld. De wrapper blijft staan bij
     een vervanging, dus dit hoeft maar een keer. */
  function zonderTransform(b) {
    var sec = b.closest ? b.closest('.shopify-section') : null;
    if (!sec || sec.dataset.dfVast) return;
    sec.dataset.dfVast = '1';
    sec.style.transition = 'none';
    sec.style.transform = 'none';
  }

  function zetPaneelKlas(b, open) {
    if (open) zonderTransform(b);
    b.classList.toggle('df-fb--open', open);
    document.documentElement.classList.toggle(LOCK, open);
    Array.prototype.forEach.call(b.querySelectorAll('[data-df-fb-open]'), function (k) {
      k.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function zetPaneel(open) {
    var b = balk();
    if (!b) return;
    zetPaneelKlas(b, open);
    var doel = open ? b.querySelector('[data-df-fb-close]') : b.querySelector('.df-fb__knop');
    if (doel) {
      try { doel.focus({ preventScroll: true }); } catch (e) { /* laat maar */ }
    }
    zweef();
  }

  /* Alleen scrollen als het grid nog onder de vouw staat; wie halverwege het
     grid de zwevende knop gebruikte, blijft waar hij was. */
  function naarGridAlsNodig() {
    var g = grid();
    if (!g) return;
    var r = g.getBoundingClientRect();
    if (r.top > window.innerHeight * 0.6 || r.bottom < 0) naarBovenGrid();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var open = e.target.closest('[data-df-fb-open]');
    if (open) { zetPaneel(true); return; }
    var dicht = e.target.closest('[data-df-fb-close]');
    if (!dicht) return;
    zetPaneel(false);
    if (dicht.hasAttribute('data-df-fb-naar-grid')) naarGridAlsNodig();
  });

  /* De zwevende knop: dezelfde knop als in de pagina, onderin het scherm
     zodra de gewone knop boven uit beeld is en het grid nog in beeld is. Op
     een breed scherm nooit; met het paneel open ook niet, en in een echt
     lege collectie ook niet (SHOP-4).

     Sinds 17-10-2026 is dit de enige zwevende knop (audit EXTRA-3). De
     filterbalk had er nog een voor het eerste scherm, die er al stond
     zolang de gewone knop nog onder de vouw lag; op een autopagina lag hij
     zo over de merk- en categoriechips heen. Luuk: pas tonen als de knop in
     de pagina boven uit beeld is gescrold. Dat is precies kr.bottom < 0
     hieronder. Bewust geen IntersectionObserver als enige trigger: springt
     de pagina in een keer over de knop heen (snel vegen, een anker, terug
     in de geschiedenis), dan is de knop voor en na niet in beeld en meldt
     zo'n observer niets (gezien 11-10-2026); de scrollluisteraar eronder
     kijkt een keer per beeld en mist dat niet. */
  function zweef() {
    var b = balk();
    if (!b) return;
    var z = b.querySelector('[data-df-fb-zweef]');
    if (!z) return;
    var k = b.querySelector('.df-fb__knop');
    var g = grid();
    var toon = false;
    if (!BREED.matches && k && g && !b.classList.contains('df-fb--open') && !leeg()) {
      var kr = k.getBoundingClientRect(), gr = g.getBoundingClientRect();
      toon = kr.bottom < 0 && gr.bottom > window.innerHeight * 0.4;
    }
    if (toon) zonderTransform(b);
    z.hidden = !toon;
  }
  var zweefWacht = false;
  function zweefPlan() {
    if (zweefWacht) return;
    zweefWacht = true;
    window.requestAnimationFrame(function () { zweefWacht = false; zweef(); });
  }
  window.addEventListener('scroll', zweefPlan, { passive: true });
  window.addEventListener('resize', function () {
    /* Gedraaid naar breed met het paneel open: het formulier staat dan weer
       gewoon in de pagina, dus de blokkade op het scrollen moet weg. */
    if (BREED.matches && paneelOpen()) zetPaneel(false);
    zweefPlan();
  });

  /* ---------- generaties van een ander merk ----------
     Op Alle BMW stonden Elantra N en GR86 in het filter Generatie: een
     universeel product zit in meerdere merkcollecties en draagt de
     chassiscodes van al die merken (gezien 10-10-2026). De sectie geeft het
     merk van de pagina mee (data-df-merk); staat er geen, dan telt een
     enkel aangevinkt merkfilter. De autolijst van de autokiezer in de
     menubalk ([data-dfa-autos]) zegt welke codes bij welk merk horen. Een
     waarde gaat pas weg als geen van zijn codes bij dit merk hoort en
     minstens een van zijn codes wel bij een ander merk; een BMW-code die
     toevallig niet in de autolijst staat blijft dus gewoon staan. */

  var merkCodes = null;

  function codesVan(label) {
    return String(label || '').split('(')[0].toUpperCase().split(/[^A-Z0-9.]+/)
      .filter(function (t) { return t.length >= 2; });
  }

  function alleMerkCodes() {
    if (merkCodes) return merkCodes;
    merkCodes = {};
    var bron = document.querySelector('[data-dfa-autos]');
    var rijen = [];
    if (bron) { try { rijen = JSON.parse(bron.textContent) || []; } catch (e) { rijen = []; } }
    rijen.forEach(function (r) {
      var m = String(r.m || '');
      if (!m) return;
      var set = merkCodes[m] || (merkCodes[m] = {});
      codesVan(r.l).forEach(function (t) { set[t] = true; });
    });
    return merkCodes;
  }

  function verbergVreemd() {
    var b = balk();
    if (!b) return;
    var merk = b.getAttribute('data-df-merk') || '';
    if (!merk) {
      var aan = b.querySelectorAll('input[name="filter.p.m.custom.make"]:checked');
      if (aan.length === 1) merk = aan[0].value;
    }
    if (!merk) return;
    var alle = alleMerkCodes();
    var eigen = alle[merk];
    if (!eigen) return;
    Array.prototype.forEach.call(b.querySelectorAll('input[name="filter.p.m.custom.chassis"]'), function (i) {
      var opt = i.closest('.df-fb__opt');
      if (!opt) return;
      var vanEigen = false, vanAnder = false;
      codesVan(i.value).forEach(function (t) {
        if (eigen[t]) { vanEigen = true; return; }
        for (var m in alle) {
          if (m !== merk && alle[m][t]) { vanAnder = true; break; }
        }
      });
      opt.classList.toggle('df-fb__opt--vreemd', !vanEigen && vanAnder && !i.checked);
    });
  }

  /* ---------- de telling op de zoekpagina ----------
     Op de zoekpagina vervangt een vinkje alleen de balk en het grid; de
     regel "n resultaten voor ..." staat in de kopsectie en gaat hier mee.
     De balk draagt het aantal (data-df-zoek-aantal), de regel zijn eigen
     sjablonen. Boven de duizend telt Shopify niet verder. */
  function zoekTel() {
    var b = balk();
    if (!b || !b.hasAttribute('data-df-zoek-aantal')) return;
    var n = parseInt(b.getAttribute('data-df-zoek-aantal'), 10);
    var tel = document.querySelector('[data-df-tel]');
    if (isNaN(n) || !tel) return;
    var sjabloon = tel.getAttribute(n === 0 ? 'data-tel-geen' : n === 1 ? 'data-tel-een' : 'data-tel-meer');
    if (!sjabloon) return;
    tel.textContent = sjabloon.replace('[aantal]', n >= 1000 ? '1000+' : String(n))
                              .replace('[term]', tel.getAttribute('data-term') || '');
  }

  /* Zoeken binnen een lange lijst. Alleen tonen wat past; blijft er niets
     over, dan komt de regel Niets gevonden tevoorschijn. Puur cosmetisch, de
     vinkjes eronder blijven staan waar ze staan. */
  document.addEventListener('input', function (e) {
    var veld = e.target;
    if (!veld || !veld.hasAttribute || !veld.hasAttribute('data-df-zoek')) return;
    var pop = veld.closest('.df-fb__pop');
    if (!pop) return;
    var t = veld.value.trim().toLowerCase();
    var over = 0;
    Array.prototype.forEach.call(pop.querySelectorAll('.df-fb__opt'), function (o) {
      if (o.classList.contains('df-fb__opt--vreemd')) return;
      var raak = t === '' || o.textContent.toLowerCase().indexOf(t) !== -1;
      o.classList.toggle('df-fb__opt--weg', !raak);
      if (raak) over++;
    });
    var niks = pop.querySelector('[data-df-niks]');
    if (niks) niks.style.display = over === 0 ? 'block' : 'none';
  });

  /* ---------- prijs met een schuifbalk ----------
     De twee getalvakken blijven staan: zonder JavaScript zijn zij het filter,
     en wie een exact bedrag weet tikt dat sneller in dan hij het schuift. De
     balk erboven schrijft in diezelfde vakken, dus er is maar een waarheid.

     De stand loopt van 0 tot 1000 en is niet hetzelfde als het bedrag. Het
     bereik in deze shop loopt tot 48.400 euro terwijl de helft van de
     artikelen onder de 700 zit; recht verdeeld zou alles wat de bezoeker
     zoekt in de eerste centimeter geplet zitten. De sectie geeft daarom een
     macht mee: bij een breed bereik staat de helft van de balk op vijf
     procent van het hoogste bedrag. Bij een smal bereik is de macht een en is
     de balk gewoon recht.

     De bedragen worden afgerond op iets leesbaars - per vijf onderin, per
     tweehonderdvijftig bovenin - want een filter op 4.237 euro zegt niemand
     iets.

     Slepen doen we zelf. Twee bereikvelden over elkaar heen betekent dat de
     bovenste greep de onderste afdekt zodra ze bij elkaar staan, en dan zit
     je vast. Daarom vangen de velden zelf niets op (pointer-events staat uit
     in de sectie) en kijken we bij het aanraken welke greep het dichtst bij
     ligt. Ligt de aanraking buiten beide grepen, dan pakken we de greep aan
     die kant - zo werkt een tik op de baan ook gewoon. Pijltjestoetsen blijven
     wel gewoon van de velden zelf. */

  function schuifVan(el) {
    return (el && el.closest) ? el.closest('[data-df-sch]') : null;
  }
  function grepen(sch) {
    return { lo: sch.querySelector('[data-df-sch-veld="min"]'),
             hi: sch.querySelector('[data-df-sch-veld="max"]') };
  }
  function vakken(sch) {
    var pop = sch.closest('.df-fb__pop') || sch.parentNode;
    return { lo: pop.querySelector('[data-df-prijs="min"]'),
             hi: pop.querySelector('[data-df-prijs="max"]') };
  }
  function afronden(v) {
    if (v <= 100) return Math.round(v / 5) * 5;
    if (v <= 1000) return Math.round(v / 25) * 25;
    if (v <= 5000) return Math.round(v / 50) * 50;
    return Math.round(v / 250) * 250;
  }
  function naarEuro(stand, max, macht) {
    /* Nooit boven het hoogste bedrag uitkomen: afronden gaat per 250 en zou
       er anders overheen schieten, en dan staat er een bedrag in het vak dat
       het getalveld zelf al te hoog vindt. */
    return Math.min(max, afronden(max * Math.pow(stand / 1000, macht)));
  }
  function naarStand(euro, max, macht) {
    if (!(max > 0)) return 0;
    var deel = Math.max(0, Math.min(1, euro / max));
    return Math.round(1000 * Math.pow(deel, 1 / macht));
  }
  function geld(n) {
    try { return '\u20ac ' + n.toLocaleString(); } catch (e) { return '\u20ac ' + n; }
  }

  /* Alleen de baan en de voorleestekst; de getalvakken blijven zoals ze zijn.
     Dat laatste is nodig terwijl iemand in zo'n vak staat te typen: wie "1"
     intikt zou anders meteen een afgerond bedrag terugkrijgen. */
  function tekenBaan(sch) {
    var g = grepen(sch);
    if (!g.lo || !g.hi) return;
    var max = parseFloat(sch.getAttribute('data-max')) || 0;
    var macht = parseFloat(sch.getAttribute('data-macht')) || 1;
    var lo = parseInt(g.lo.value, 10) || 0;
    var hi = parseInt(g.hi.value, 10);
    if (isNaN(hi)) hi = 1000;
    var vul = sch.querySelector('[data-df-sch-vul]');
    if (vul) {
      vul.style.left = (lo / 10) + '%';
      vul.style.right = (100 - hi / 10) + '%';
    }
    g.lo.setAttribute('aria-valuetext', geld(naarEuro(lo, max, macht)));
    g.hi.setAttribute('aria-valuetext', geld(hi >= 1000 ? max : naarEuro(hi, max, macht)));
  }

  /* En hier wel de vakken mee. Een greep helemaal links of helemaal rechts
     betekent geen grens: het vak blijft leeg, gaat niet mee in het adres en
     laat zijn plaatshouder zien. */
  function teken(sch) {
    tekenBaan(sch);
    var g = grepen(sch), vak = vakken(sch);
    if (!g.lo || !g.hi) return;
    var max = parseFloat(sch.getAttribute('data-max')) || 0;
    var macht = parseFloat(sch.getAttribute('data-macht')) || 1;
    var lo = parseInt(g.lo.value, 10) || 0;
    var hi = parseInt(g.hi.value, 10);
    if (isNaN(hi)) hi = 1000;
    if (vak.lo) vak.lo.value = lo <= 0 ? '' : String(naarEuro(lo, max, macht));
    if (vak.hi) vak.hi.value = hi >= 1000 ? '' : String(naarEuro(hi, max, macht));
  }

  function zetGreep(sch, greep, stand) {
    var g = grepen(sch);
    if (!g.lo || !g.hi) return;
    if (greep === g.lo) stand = Math.min(stand, parseInt(g.hi.value, 10));
    else stand = Math.max(stand, parseInt(g.lo.value, 10));
    greep.value = Math.max(0, Math.min(1000, stand));
    teken(sch);
  }

  function standUitX(sch, x) {
    var baan = sch.querySelector('.df-fb__sch-baan');
    var r = (baan || sch).getBoundingClientRect();
    if (!r.width) return 0;
    return Math.max(0, Math.min(1000, Math.round((x - r.left) / r.width * 1000)));
  }

  /* De vakken zijn leidend bij het inladen en na elke vervanging: de sectie
     rendert de grepen altijd op wijd open en zet er geen stand in, want die
     stand hangt van de macht af en dat rekent Liquid niet. */
  function uitVakken(sch) {
    var g = grepen(sch), vak = vakken(sch);
    if (!g.lo || !g.hi) return;
    var max = parseFloat(sch.getAttribute('data-max')) || 0;
    var macht = parseFloat(sch.getAttribute('data-macht')) || 1;
    var lo = (vak.lo && vak.lo.value !== '') ? naarStand(parseFloat(vak.lo.value), max, macht) : 0;
    var hi = (vak.hi && vak.hi.value !== '') ? naarStand(parseFloat(vak.hi.value), max, macht) : 1000;
    if (lo > hi) lo = hi;
    g.lo.value = lo;
    g.hi.value = hi;
    tekenBaan(sch);
  }

  function schuiven() {
    var b = balk();
    return b ? Array.prototype.slice.call(b.querySelectorAll('[data-df-sch]')) : [];
  }
  function stelSchuivenIn() {
    schuiven().forEach(uitVakken);
  }

  /* Loslaten is het gebaar dat zegt: zo wil ik het. Toch even wachten, want
     met de pijltjestoetsen komt er per aanslag een change langs en dan zou
     elke tik een opvraging worden. Is er niets veranderd aan wat er al in het
     adres staat, dan gebeurt er niets. */
  var prijsWacht = null;
  function pasPrijsToe(sch) {
    if (prijsWacht) clearTimeout(prijsWacht);
    prijsWacht = setTimeout(function () {
      prijsWacht = null;
      var vak = vakken(sch);
      if (!vak.lo || !vak.hi) return;
      var u = new URL(window.location.href);
      if ((u.searchParams.get(vak.lo.name) || '') === vak.lo.value &&
          (u.searchParams.get(vak.hi.name) || '') === vak.hi.value) return;
      var form = sch.closest('form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }, 350);
  }

  var sleept = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    var sch = schuifVan(e.target);
    if (!sch) return;
    var g = grepen(sch);
    if (!g.lo || !g.hi) return;
    var stand = standUitX(sch, e.clientX);
    var lo = parseInt(g.lo.value, 10) || 0;
    var hi = parseInt(g.hi.value, 10);
    if (isNaN(hi)) hi = 1000;
    var pak;
    if (stand <= lo) pak = g.lo;
    else if (stand >= hi) pak = g.hi;
    else pak = (stand - lo <= hi - stand) ? g.lo : g.hi;
    sleept = { sch: sch, greep: pak };
    try { sch.setPointerCapture(e.pointerId); } catch (er) { /* oudere browser */ }
    e.preventDefault();
    zetGreep(sch, pak, stand);
    try { pak.focus({ preventScroll: true }); } catch (er) { /* laat maar */ }
  });

  document.addEventListener('pointermove', function (e) {
    if (!sleept) return;
    zetGreep(sleept.sch, sleept.greep, standUitX(sleept.sch, e.clientX));
  });

  function losLaten() {
    if (!sleept) return;
    var sch = sleept.sch;
    sleept = null;
    pasPrijsToe(sch);
  }
  document.addEventListener('pointerup', losLaten);
  document.addEventListener('pointercancel', losLaten);

  /* Pijltjestoetsen komen wel gewoon bij het veld zelf binnen. */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    if (el.getAttribute('data-df-sch-veld')) {
      var sch = schuifVan(el);
      if (sch) zetGreep(sch, el, parseInt(el.value, 10) || 0);
      return;
    }
    if (el.getAttribute('data-df-prijs')) {
      var sch2 = null;
      var pop = el.closest ? el.closest('.df-fb__pop') : null;
      if (pop) sch2 = pop.querySelector('[data-df-sch]');
      if (sch2) uitVakken(sch2);
    }
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute || !el.getAttribute('data-df-sch-veld')) return;
    var sch = schuifVan(el);
    if (sch) pasPrijsToe(sch);
  });

  /* ---------- stand van de balk bewaren over een vervanging heen ----------
     Wie drie merken aanvinkt wil niet dat de uitklapper na het eerste vinkje
     dichtklapt. We onthouden dus welk filter openstond, hoe ver de lijst
     gescrold was en welk vakje de aandacht had, en zetten dat terug. Het
     label van de uitklapper is de sleutel; het aantal erachter verandert
     namelijk juist wel. */

  function labelVan(g) {
    var sum = g.querySelector('summary');
    if (!sum) return '';
    var knoop = sum.firstChild;
    while (knoop && knoop.nodeType !== 3) knoop = knoop.nextSibling;
    return (knoop ? knoop.textContent : sum.textContent).trim();
  }

  function standNu() {
    var b = balk();
    if (!b) return null;
    var s = { label: null, scroll: 0, vink: null, zoek: null, greep: null, paneel: false, vormScroll: 0 };
    s.paneel = b.classList.contains('df-fb--open');
    var vorm = b.querySelector('[data-df-fb-vorm]');
    if (vorm) s.vormScroll = vorm.scrollTop;
    var open = b.querySelector('.df-fb__grp[open]');
    if (open) {
      s.label = labelVan(open);
      var lijst = open.querySelector('.df-fb__lijst');
      if (lijst) s.scroll = lijst.scrollTop;
      var zoek = open.querySelector('[data-df-zoek]');
      if (zoek && zoek.value) s.zoek = zoek.value;
    }
    var nu = document.activeElement;
    if (nu && nu.type === 'checkbox' && b.contains(nu)) {
      s.vink = { naam: nu.name, waarde: nu.value };
    }
    if (nu && nu.getAttribute && b.contains(nu) && nu.getAttribute('data-df-sch-veld')) {
      s.greep = nu.getAttribute('data-df-sch-veld');
    }
    return s;
  }

  function zetTerug(s) {
    if (!s) return;
    var b = balk();
    if (!b) return;
    /* Eerst het paneel, dan pas de uitklapper erin: de scrolstand van het
       paneel klopt pas als de lijst weer openstaat, dus die komt onderaan. */
    if (s.paneel) zetPaneelKlas(b, true);
    var vorm = b.querySelector('[data-df-fb-vorm]');
    if (!s.label) {
      if (s.paneel && vorm) vorm.scrollTop = s.vormScroll;
      return;
    }
    var raak = null;
    groepen().forEach(function (g) { if (!raak && labelVan(g) === s.label) raak = g; });
    if (!raak) {
      if (s.paneel && vorm) vorm.scrollTop = s.vormScroll;
      return;
    }
    raak.open = true;

    if (s.zoek) {
      var zoek = raak.querySelector('[data-df-zoek]');
      if (zoek) {
        zoek.value = s.zoek;
        zoek.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    var lijst = raak.querySelector('.df-fb__lijst');
    if (lijst) lijst.scrollTop = s.scroll;

    if (s.vink) {
      var doel = null;
      Array.prototype.forEach.call(raak.querySelectorAll('input[type="checkbox"]'), function (i) {
        if (!doel && i.name === s.vink.naam && i.value === s.vink.waarde) doel = i;
      });
      /* preventScroll, want anders springt de pagina alsnog naar het vinkje -
         precies wat we hier aan het voorkomen zijn. Oudere browsers negeren
         die optie; die krijgen geen focus in plaats van een sprong. */
      if (doel) {
        try { doel.focus({ preventScroll: true }); } catch (e) { /* laat maar */ }
      }
    }

    if (s.greep) {
      var greep = raak.querySelector('[data-df-sch-veld="' + s.greep + '"]');
      if (greep) {
        try { greep.focus({ preventScroll: true }); } catch (e) { /* laat maar */ }
      }
    }

    if (s.paneel && vorm) vorm.scrollTop = s.vormScroll;
  }

  /* ---------- ophalen en vervangen ---------- */

  var lopend = null;
  /* De geschiedenisstap die nu op het scherm staat; zie popstate onderaan. */
  var staat = window.history.state;
  /* Pad plus zoekdeel van wat er nu op het scherm staat. Verandert bij terug
     of vooruit alleen het #anker, dan valt er niets op te halen. */
  var gerenderd = window.location.pathname + window.location.search;

  /* Hetzelfde adres als in de adresbalk, het #anker niet meegeteld. */
  function zelfdeAdres(adres) {
    var a = new URL(adres, window.location.href);
    var b = new URL(window.location.href);
    a.hash = '';
    b.hash = '';
    return a.href === b.href;
  }

  function vervang(id, html) {
    var doel = document.getElementById('shopify-section-' + id);
    if (!doel || !html) return;
    var vers = new DOMParser().parseFromString(html, 'text/html')
                              .getElementById('shopify-section-' + id);
    doel.innerHTML = vers ? vers.innerHTML : html;
  }

  /* ---------- de chipbalk erboven (df-shopfilter) ----------
     Die gaat bij elk vinkje mee. Het aantal artikelen rechts en de actieve
     merkchip hangen namelijk van de filters af, en bleven anders staan op
     wat er bij het inladen gold (gezien 9-10-2026: 10 kaarten in het grid,
     "11 artikelen" erboven). Twee dingen bestaan alleen in de browser: de
     chip met je eigen auto, die df-auto.js er bij het inladen voor zet, en
     hoe ver de merkenrij op een telefoon opzij geschoven is. Die nemen we
     over de vervanging heen mee; wissel() hieronder doet hetzelfde. */

  function chipSectie() {
    var bar = document.querySelector('.df-sf__bar');
    var s = bar ? bar.closest('.shopify-section') : null;
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  function chipStand() {
    var bar = document.querySelector('.df-sf__bar');
    var merk = document.querySelector('.df-sf__grp--merk');
    return {
      zij: merk ? merk.scrollLeft : 0,
      auto: bar ? bar.querySelector('[data-dfa-chip]') : null
    };
  }

  function chipsTerug(s) {
    var bar = document.querySelector('.df-sf__bar');
    if (s.auto && bar && !bar.querySelector('[data-dfa-chip]')) {
      var grp = s.auto.closest('.df-sf__grp');
      if (grp) bar.insertBefore(grp, bar.firstChild);
      var eigen = new URL(s.auto.href, window.location.href).pathname === window.location.pathname;
      s.auto.classList.toggle('on', eigen);
      if (eigen) s.auto.setAttribute('aria-current', 'page');
      else s.auto.removeAttribute('aria-current');
    }
    var merk = document.querySelector('.df-sf__grp--merk');
    if (merk && s.zij) merk.scrollLeft = s.zij;
  }

  /* Na een paginawissel naar de bovenkant van het grid, niet naar de
     filterbalk: op een telefoon is die balk zeven rijen hoog en dan stond de
     eerste kaart van de nieuwe pagina nog onder de vouw (gezien 10-10-2026,
     eerste kaart op 562 van 664 px). De menubalk telt mee in de marge, want
     die schuift bij omhoog scrollen weer in beeld. */
  function naarBovenGrid() {
    var doel = grid() || balk();
    if (!doel) return;
    var kop = document.querySelector('.hdr');
    var marge = (kop ? kop.getBoundingClientRect().height : 0) + 12;
    var y = window.pageYOffset + doel.getBoundingClientRect().top - marge;
    window.scrollTo({ top: Math.max(0, y), behavior: RUSTIG.matches ? 'auto' : 'smooth' });
  }

  function ga(adres, opties) {
    opties = opties || {};
    var b = balk();
    var g = grid();
    var ids = [sectieVan(b), sectieVan(g)].filter(Boolean);
    if (!ids.length || !window.fetch || !window.DOMParser) {
      window.location.href = adres;
      return;
    }
    var chipId = chipSectie();
    if (chipId) ids.push(chipId);

    var bewaard = standNu();
    if (g) g.setAttribute('aria-busy', 'true');

    /* Klikt iemand drie vinkjes achter elkaar, dan telt alleen de laatste. */
    if (lopend) lopend.abort();
    var af = ('AbortController' in window) ? new AbortController() : null;
    lopend = af;

    /* Zonder het #anker: anders kwam ?sections= in het anker terecht in
       plaats van in het zoekdeel, en gaf de server de hele pagina terug in
       plaats van de secties (gezien 11-10-2026). */
    var kaal = adres.split('#')[0];
    var scheiding = kaal.indexOf('?') > -1 ? '&' : '?';
    fetch(kaal + scheiding + 'sections=' + ids.join(','),
          af ? { signal: af.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('sectie niet opgehaald');
        return r.json();
      })
      .then(function (d) {
        lopend = null;
        var chips = chipStand();
        ids.forEach(function (id) { vervang(id, d[id]); });
        chipsTerug(chips);
        merkJs();
        zetLeeg();
        stelSchuivenIn();
        zetTerug(bewaard);
        verbergVreemd();
        zoekTel();
        zweef();
        var g2 = grid();
        if (g2) g2.removeAttribute('aria-busy');
        if (opties.push !== false) {
          staat = { dfShop: 1 };
          window.history.pushState(staat, '', adres);
        }
        gerenderd = window.location.pathname + window.location.search;
        if (opties.naarBoven) naarBovenGrid();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        /* Niet blijven hangen met een half scherm: dan maar op de gewone
           manier, precies zoals het zonder dit script zou gaan. Staat dat
           adres al in de adresbalk (bij terug of vooruit), dan herladen we.
           Hetzelfde adres nog eens toewijzen is met een #anker erin alleen
           een ankerstap, en die gaf weer een popstate: een lus. */
        if (zelfdeAdres(adres)) {
          if (opties.push === false) window.location.reload();
          else if (g) g.removeAttribute('aria-busy');
          return;
        }
        window.location.href = adres;
      });
  }

  /* ---------- naar een andere collectie zonder herladen ----------
     De categorie- en merkchips boven de filterbalk (df-shopfilter) zijn
     gewone links naar een andere collectie: van de shop naar alle-bmw, van
     alle-audi naar chiptuning. Daar laadde de browser de hele pagina opnieuw
     en stond je weer bovenaan, terwijl je net bij de chips zat (gemeld
     9-10-2026: een ander merk aanklikken herlaadt en springt omhoog).

     De sectie-route hierboven kan dat niet. Die rendert alleen secties uit
     de sjabloon van het opgevraagde adres, en de categorieen draaien op
     collection.json terwijl de shop en de merken op collection.bodykits.json
     staan: andere sjabloon, andere sectie-ids. Hier halen we daarom de hele
     pagina op en ruilen we alle secties onder de kop om voor de nieuwe.

     De kop zelf (df-shopkop) blijft staan. Daarin zit het kentekenveld dat
     df-auto.js bij het inladen heeft aangesloten, en zijn script heeft een
     luisteraar op document gezet; vervangen zou dat allebei kapotmaken. Alleen
     de teksten gaan mee. Heeft de nieuwe pagina een ander beeld in de kop,
     zoals een modelcollectie met zijn eigen foto of video, dan is het een
     ander soort pagina en laden we die gewoon.

     Scripts in de nieuwe secties draaien niet vanzelf, want DOMParser zet ze
     uit. Die zetten we dus opnieuw neer. De scripts die nu onder de kop staan
     (filterbalk, ook-voor) mogen twee keer draaien; een sectie die er later
     bijkomt moet dat ook kunnen. Daarna krijgt elke nieuwe sectie dezelfde
     shopify:section:load als in de editor, zodat df-motion.js de blokken met
     .rv laat verschijnen.

     Na de wissel staan de chips op dezelfde hoogte in beeld als voor de
     klik, en de merkenrij op een telefoon op dezelfde zijwaartse stand. */

  var getoond = window.location.pathname;
  var KOPTEKST = ['.eyebrow', 'h1', '.df-sk__sub', '.df-sk__gekozen'];

  function kopVan(root) { return root.querySelector('header[class^="df-sk-"]'); }

  function sjabloonSecties(root) {
    var main = root.getElementById('MainContent');
    if (!main) return [];
    return Array.prototype.filter.call(main.children, function (el) {
      return el.id && el.id.indexOf('shopify-section-template--') === 0;
    });
  }

  /* Alles in de kop behalve de teksten: het beeld, en welke tekstregels er
     zijn. Is dat gelijk, dan hoeven alleen de teksten om. */
  function kopBeeld(kop) {
    var delen = [];
    Array.prototype.forEach.call(kop.querySelectorAll('img.df-sk__foto, video, video source'), function (m) {
      delen.push(m.tagName + ' ' + (m.getAttribute('src') || '') + ' ' + (m.getAttribute('poster') || ''));
    });
    KOPTEKST.forEach(function (s) { delen.push(s + (kop.querySelector(s) ? '+' : '-')); });
    return delen.join('|');
  }

  function draaiScripts(sectie, geladen) {
    Array.prototype.forEach.call(sectie.querySelectorAll('script'), function (oud) {
      var src = oud.getAttribute('src');
      if (src && geladen[src]) return;
      var vers = document.createElement('script');
      Array.prototype.forEach.call(oud.attributes, function (at) { vers.setAttribute(at.name, at.value); });
      if (!src) vers.text = oud.text;
      oud.parentNode.replaceChild(vers, oud);
    });
  }

  /* Meteen laten zien welke chip je raakte; de server zet een paar honderd
     milliseconden later de echte stand neer. */
  function zetChipAan(a) {
    var grp = a.closest('.df-sf__grp');
    if (!grp) return;
    Array.prototype.forEach.call(grp.querySelectorAll('.df-sf__chip'), function (c) {
      c.classList.toggle('on', c === a);
    });
  }

  function wissel(adres, opties) {
    opties = opties || {};
    function gewoon() {
      if (opties.push === false) window.location.reload();
      else window.location.href = adres;
    }
    var oudKop = kopVan(document);
    var oud = sjabloonSecties(document);
    if (!oudKop || oud.length < 2 || oud[0] !== oudKop.closest('.shopify-section') ||
        !window.fetch || !window.DOMParser) {
      gewoon();
      return;
    }

    if (lopend) lopend.abort();
    var af = ('AbortController' in window) ? new AbortController() : null;
    lopend = af;
    var g = grid();
    if (g) g.setAttribute('aria-busy', 'true');

    var naar = adres;
    fetch(adres, af ? { signal: af.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('pagina niet opgehaald');
        if (r.redirected && r.url) naar = r.url;
        return r.text();
      })
      .then(function (html) {
        lopend = null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nieuwKop = kopVan(doc);
        var nieuw = sjabloonSecties(doc);
        if (!nieuwKop || nieuw.length < 2 || nieuw[0] !== nieuwKop.closest('.shopify-section') ||
            !doc.querySelector('.df-sf__bar') || kopBeeld(nieuwKop) !== kopBeeld(oudKop)) {
          throw new Error('ander soort pagina');
        }

        /* Wat we na de wissel terug willen zien. */
        var oudBar = document.querySelector('.df-sf__bar');
        var hoogte = oudBar ? oudBar.getBoundingClientRect().top : null;
        var focus = oudBar && oudBar.contains(document.activeElement);
        var chips = chipStand();
        var geladen = {};
        Array.prototype.forEach.call(document.scripts, function (s) {
          var src = s.getAttribute('src');
          if (src) geladen[src] = true;
        });

        KOPTEKST.forEach(function (s) {
          var a = oudKop.querySelector(s), b = nieuwKop.querySelector(s);
          if (a && b && a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
        });

        var ouder = oud[0].parentNode;
        var anker = oud[oud.length - 1].nextSibling;
        oud.slice(1).forEach(function (el) { ouder.removeChild(el); });
        var erin = nieuw.slice(1).map(function (el) {
          var kopie = document.importNode(el, true);
          ouder.insertBefore(kopie, anker);
          return kopie;
        });
        erin.forEach(function (s) { draaiScripts(s, geladen); });

        if (opties.push !== false) {
          staat = { dfShop: 1, wissel: 1 };
          window.history.pushState(staat, '', naar);
        }
        var vanPad = getoond;
        getoond = window.location.pathname;
        gerenderd = window.location.pathname + window.location.search;
        if (doc.title) document.title = doc.title;

        /* De taalkeuze in de kop stuurt je terug naar het adres van het
           inladen; dat is nu een andere collectie. */
        Array.prototype.forEach.call(document.querySelectorAll('input[name="return_to"]'), function (i) {
          var v = i.value || '';
          if (v.split('?')[0] !== vanPad) return;
          i.value = v.indexOf('?') > -1 ? getoond + window.location.search : getoond;
        });

        chipsTerug(chips);
        var bar = document.querySelector('.df-sf__bar');
        if (bar && hoogte !== null) {
          var y = window.pageYOffset + bar.getBoundingClientRect().top - hoogte;
          try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
        }

        if (focus && bar && opties.chip) {
          var terug = null;
          Array.prototype.forEach.call(bar.querySelectorAll('a.df-sf__chip'), function (c) {
            if (!terug && c.getAttribute('href') === opties.chip) terug = c;
          });
          if (terug) {
            try { terug.focus({ preventScroll: true }); } catch (e) { /* laat maar */ }
          }
        }

        merkJs();
        zetLeeg();
        stelSchuivenIn();
        verbergVreemd();
        zweef();
        erin.forEach(function (s) {
          s.dispatchEvent(new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: s.id.replace('shopify-section-', '') }
          }));
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        gewoon();
      });
  }

  /* ---------- wat we opvangen ---------- */

  function zonderPagina(u) {
    u.searchParams.delete('page');
    return u.pathname + (u.search || '');
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    var b = balk();
    if (!b || !el || !b.contains(el)) return;

    if (el.name === 'sort_by') {
      var u = new URL(window.location.href);
      if (el.value) u.searchParams.set('sort_by', el.value);
      else u.searchParams.delete('sort_by');
      ga(zonderPagina(u));
      return;
    }

    if (el.type === 'checkbox') {
      var naar = el.getAttribute('data-df-url');
      if (naar) ga(naar);
    }
  });

  /* De prijsvakken hebben geen eigen adres; die komen via het formulier
     binnen. Alle aangevinkte filters staan er als velden in, dus dit is
     dezelfde uitkomst als de gewone verzending - alleen zonder herladen. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var b = balk();
    if (!b || !form || !b.contains(form)) return;
    e.preventDefault();
    var u = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
    u.search = '';
    var velden = new FormData(form);
    velden.forEach(function (waarde, naam) {
      if (waarde !== '') u.searchParams.append(naam, waarde);
    });
    ga(u.pathname + (u.search || ''));
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;

    /* Niet in de editor: die houdt zelf bij welke sjabloon er open staat. */
    if (a.classList.contains('df-sf__chip') && a.closest('.df-sf__bar') &&
        !(window.Shopify && window.Shopify.designMode)) {
      var doel = new URL(a.href, window.location.href);
      if (doel.origin !== window.location.origin) return;
      e.preventDefault();
      if (doel.pathname + doel.search === window.location.pathname + window.location.search) return;
      zetChipAan(a);
      wissel(doel.pathname + doel.search, { chip: a.getAttribute('href') });
      return;
    }

    var b = balk();
    var g = grid();
    var uitBalk = b && b.contains(a) &&
                  (a.classList.contains('df-fb__pil') ||
                   a.classList.contains('df-fb__wis') ||
                   a.classList.contains('df-fb__leegmaak'));
    var uitPaginering = g && g.contains(a) && !!a.closest('.df-pgr__pag');
    if (!uitBalk && !uitPaginering) return;

    e.preventDefault();
    /* Bij paginering hoor je wel bovenaan de nieuwe pagina te beginnen - daar
       is het juist verwarrend om halverwege een andere lijst te blijven staan. */
    ga(a.getAttribute('href'), { naarBoven: uitPaginering });
  });

  /* Terug en vooruit. Was de stap die we terugzetten een chipwissel, dan
     gaat het via wissel(). Het adres alleen zegt dat niet altijd: de chip van
     een merk zonder eigen collectie (Porsche) blijft op de shop en zet
     alleen een merkfilter aan, en dan moeten de kop en de chips ook terug. */
  window.addEventListener('popstate', function (e) {
    if (!balk()) return;
    /* Alleen het #anker veranderd: een skiplink, #MainContent, of terug van
       zo'n ankerstap. Het scherm klopt dan al. Hier toch ophalen gaf op
       /search en de collecties een eindeloze lus (gezien 11-10-2026: elke
       100 tot 500 ms een popstate). Een ankerstap heeft geen eigen staat,
       dus dan blijft de vorige gelden. */
    if (window.location.pathname + window.location.search === gerenderd) {
      if (e.state) staat = e.state;
      return;
    }
    var viaChip = (staat && staat.wissel) || (e.state && e.state.wissel) ||
                  window.location.pathname !== getoond;
    staat = e.state;
    if (viaChip) wissel(window.location.href, { push: false });
    else ga(window.location.href, { push: false });
  });

  document.addEventListener('shopify:section:load', function () {
    merkJs();
    zetLeeg();
    stelSchuivenIn();
    verbergVreemd();
    zweef();
  });
  merkJs();
  zetLeeg();
  stelSchuivenIn();
  verbergVreemd();
  zweef();
})();
